import { render, staticRenderFns } from "./general-statistics-dossier.vue?vue&type=template&id=4af3a59c&"
import script from "./general-statistics-dossier.ts?vue&type=script&lang=ts&"
export * from "./general-statistics-dossier.ts?vue&type=script&lang=ts&"
import style0 from "../../shared/styles/statistical-analysis-dossier.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports